require('./index.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/analysis-charts/analysis-charts-module')
require('../components/error-handler/error-handler-module')
require('../components/analyze-access/analyze-access-module')

# Load Css
require('../../../sass/web/html/_history.scss')

require('./period-filter/period-filter.jade')

HistoryCtrl = require('./index-controller')
HistoryService = require('./history-service')
HistoryPeriodFilterCtrl = require('./period-filter/period-filter-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-analysis-charts'
  'gnp-error-handler'
  'gnp-analyze-access'
]
angular.module 'gnp-app-history', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/history',
      templateUrl: 'web/history/index.jade'
      controller: 'HistoryCtrl'
      title: '_HISTORY.TITLE'
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
      permission:
        signInRequired: false
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'HistoryCtrl', HistoryCtrl
  .controller 'HistoryPeriodFilterCtrl', HistoryPeriodFilterCtrl
  .factory 'HistoryService', HistoryService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/history/index-module.coffee